<template>
    <b-container fluid>
        <b-overlay :show="unitLoad">
            <iq-card>
                <template v-slot:body>
                    <b-row class="mb-3">
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('globalTrans.fiscal_year') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getFiscalYear(dataArray.fiscal_year_id) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.circular_memo_no') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getCircularMemo(dataArray.circular_publication_id) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.training_title') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getTraining(dataArray.training_title_id) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.batch') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getBatch(dataArray.batch_id) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.total_pre_assessment_number') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ $n(dataArray.total_pre_evaluation) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.total_final_assessment_number') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ $n(dataArray.total_post_evaluation) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.total_trainee_code_of_conduct') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ $n(dataArray.total_code_of_conduct) }}</span>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('sitePreference.grandTotal') }}</b>
                        </b-col>
                        <b-col class="mb-2" xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ $n(dataArray.grand_total) }}</span>
                        </b-col>
                    </b-row>
                    <b-table-simple style="font-size: 12px" bordered small>
                        <thead>
                            <b-tr>
                                <b-th style="width: 5%" class="align-middle text-center">{{ $t('globalTrans.sl_no')}}</b-th>
                                <b-th class="align-middle text-center w-20">{{ $t('trainer_trainee.trainees_name') + ', ' + $t('globalTrans.designation') + ', ' + $t('trainer_trainee.org_and_address') }}</b-th>
                                <b-th class="align-middle text-center w-15">{{ $t('trainer_trainee.pre_assessment_number') }}</b-th>
                                <b-th class="align-middle text-center w-15">{{ $t('trainer_trainee.final_assessment_number') }}</b-th>
                                <b-th class="align-middle text-center w-15">{{ $t('trainer_trainee.trainee_code_of_conduct') }}</b-th>
                                <b-th style="width: 8%" class="align-middle text-center">{{ $t('globalTrans.totalNumber') }}</b-th>
                                <b-th class="align-middle text-center">{{ $t('globalTrans.remarks') }}</b-th>
                            </b-tr>
                        </thead>
                        <tbody v-if="dataArray.details.length > 0">
                            <b-tr v-for="(item, index) in dataArray.details" :key="index">
                                <td class="align-middle text-center">{{ $n(index + 1) }}</td>
                                <td class="align-middle">
                                    <span>{{ currentLocale === 'bn' ? item.application.trainee.name_bn : item.application.trainee.name + ',' }}</span>
                                    <br><span>{{ (item.application.trainee.designation_id ? designationName(item.application.trainee.designation_id) : item.application.trainee.other_designation) + ', ' }}</span>
                                    <br><span>{{ getRegOrgName(item.application.trainee.reg_org_id) + ', ' }}</span>
                                    <br><span>{{ currentLocale == 'en' ? item.application.trainee.pre_address : item.application.trainee.pre_address_bn }}</span>
                                    <span v-if="item.application.trainee.pre_ward_id">{{ getWardName(item.application.trainee.pre_ward_id) + ', ' }}</span>
                                    <span v-if="item.application.trainee.pre_union_id">{{ getUnionName(item.application.trainee.pre_union_id) + ', ' }}</span>
                                    <span v-if="item.application.trainee.pre_city_corporation_id">{{ getCityCorpName(item.application.trainee.pre_city_corporation_id) + ', ' }}</span>
                                    <span v-if="item.application.trainee.pre_paurasabha_id">{{ getPauroshobaName(item.application.trainee.pre_paurasabha_id) + ', ' }}</span>
                                    <span v-if="item.application.trainee.pre_upazila_id">{{ getUpazilaName(item.application.trainee.pre_upazila_id) + ', ' }}</span>
                                    <span v-if="item.application.trainee.pre_district_id">{{ getDistrictName(item.application.trainee.pre_district_id) }}</span>
                                </td>
                                <td class="text-center align-middle">
                                    {{ $n(item.pre_evaluation) }}
                                </td>
                                <td class="text-center align-middle">
                                    {{ $n(item.post_evaluation) }}
                                </td>
                                <td class="text-center align-middle">
                                    {{ $n(item.code_of_conduct) }}
                                </td>
                                <td class="text-center align-middle">{{ $n(item.total_number ? item.total_number : 0) }}</td>
                                <td class="text-center align-middle">
                                    {{ item.remarks }}
                                </td>
                            </b-tr>
                        </tbody>
                    </b-table-simple>
                    <div class="row">
                        <div class="col-sm-3"></div>
                        <div class="col text-right">
                            <b-button type="button" variant="danger" class="mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.cancel') }}</b-button>
                        </div>
                    </div>
                </template>
            </iq-card>
        </b-overlay>
    </b-container>
</template>
<script>
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { getTraineeDetailApi } from '../../api/routes'

    export default {
        props: ['id'],
        data () {
            return {
                dataArray: {
                    fiscal_year_id: 0,
                    circular_publication_id: 0,
                    training_title_id: 0,
                    batch_id: 0,
                    details: [],
                    total_pre_evaluation: 0,
                    total_post_evaluation: 0,
                    total_code_of_conduct: 0,
                    grand_total: ''
                },
                unitLoad: false
            }
        },
        computed: {
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        created () {
            if (this.id) {
                const tmp = this.getTraineeEvaluationData()
                this.dataArray.fiscal_year_id = tmp.fiscal_year_id
                this.dataArray.circular_publication_id = tmp.circular_publication_id
                this.dataArray.training_title_id = tmp.training_title_id
                this.dataArray.batch_id = tmp.batch_id
                this.dataArray.total_pre_evaluation = tmp.total_pre_evaluation
                this.dataArray.total_post_evaluation = tmp.total_post_evaluation
                this.dataArray.total_code_of_conduct = tmp.total_code_of_conduct
                this.dataArray.grand_total = tmp.grand_total
                this.dataArray.id = tmp.id
                this.getTraineeInfoDetail()
            }
        },
        methods: {
            async getTraineeInfoDetail () {
                this.unitLoad = true
                await RestApi.getData(trainingElearningServiceBaseUrl, getTraineeDetailApi, this.dataArray).then(response => {
                    if (response.success) {
                        this.dataArray.details = response.data.details
                    } else {
                        this.dataArray.details = []
                    }
                    this.unitLoad = false
                })
            },
            getRegOrgName (Id) {
                const Org = this.$store.state.TrainingElearning.commonObj.registeredOrgList.find(item => item.value === Id)
                if (this.$i18n.locale === 'bn') {
                    return Org.text_bn
                } else {
                    return Org.text_en
                }
            },
            getTraineeEvaluationData () {
                const tmpData = this.$store.state.list.find(item => item.id === this.id)
                return JSON.parse(JSON.stringify(tmpData))
            },
            getFiscalYear (fiscalYearId) {
                const fiscalObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
                if (this.$i18n.locale === 'bn') {
                    return fiscalObj.text_bn
                } else {
                    return fiscalObj.text_en
                }
            },
            getCircularMemo (circularMemoId) {
                const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
                if (this.$i18n.locale === 'bn') {
                    return circularObj.text_bn
                } else {
                    return circularObj.text_en
                }
            },
            getTraining (trainingId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
                if (this.$i18n.locale === 'bn') {
                    return trainingObj.text_bn
                } else {
                    return trainingObj.text_en
                }
            },
            getBatch (batchId) {
                const batchObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === batchId)
                if (this.$i18n.locale === 'bn') {
                    return batchObj.text_bn
                } else {
                    return batchObj.text_en
                }
            },
            designationName (Id) {
                const Obj = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === Id)
                if (this.$i18n.locale === 'bn') {
                    return Obj ? Obj.text_bn : ''
                } else {
                    return Obj ? Obj.text_en : ''
                }
            },
            getWardName (Id) {
                const Obj = this.$store.state.commonObj.wardList.find(item => item.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                    return Obj.text_bn
                } else {
                    return Obj.text_en
                }
            },
            getUnionName (Id) {
                const Obj = this.$store.state.commonObj.unionList.find(item => item.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                    return Obj.text_bn
                } else {
                    return Obj.text_en
                }
            },
            getCityCorpName (Id) {
                const Obj = this.$store.state.commonObj.cityCorporationList.find(item => item.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                    return Obj.text_bn
                } else {
                    return Obj.text_en
                }
            },
            getPauroshobaName (Id) {
                const Obj = this.$store.state.commonObj.pauroshobaList.find(item => item.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                    return Obj.text_bn
                } else {
                    return Obj.text_en
                }
            },
            getUpazilaName (Id) {
                const Obj = this.$store.state.commonObj.upazilaList.find(item => item.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                    return Obj.text_bn
                } else {
                    return Obj.text_en
                }
            },
            getDistrictName (Id) {
                const Obj = this.$store.state.commonObj.districtList.find(item => item.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                    return Obj.text_bn
                } else {
                    return Obj.text_en
                }
            }
        }
    }
</script>
